import { Modal as ModalModule, UI } from 'common';
import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const { Modal, ModalButtonActionType } = ModalModule;
const { WrappedDropdownWithLabel } = UI;

const ChangeCostCodeModal = ({
	modalId,
	data: { costCodeOptions = [], setPrintsCostCode },
}) => {
	const [costCodeId, setCostCodeId] = useState('');
	const onSave = closeModal => {
		if (isFunction(setPrintsCostCode)) {
			setPrintsCostCode(costCodeId);
		}

		closeModal();
	};

	const onChangeCostCode = ({ value }) => {
		setCostCodeId(value);
	};

	return (
		<Modal
			modalId={modalId}
			className="history-cost-codes change-cost-code-modal"
			header="Change Cost Code"
			primaryButton={{
				type: ModalButtonActionType.Ok,
				text: 'Save',
				onClick: onSave,
			}}
			size="small"
		>
			<WrappedDropdownWithLabel
				label="New Cost Code:"
				uiElementConfig={{
					dataqa: 'change-cost-code-dropdown',
					options: [
						...costCodeOptions,
						{
							code: 'None',
							id: '',
						},
					],
					optionLabel: 'code',
					optionValue: 'id',
					value: costCodeId,
					onChange: onChangeCostCode,
				}}
			/>
		</Modal>
	);
};

ChangeCostCodeModal.propTypes = {
	data: PropTypes.shape({
		costCodeOptions: PropTypes.array,

		// callback to set selected prints' cost code.
		setPrintsCostCode: PropTypes.func,
	}),
};
export default ChangeCostCodeModal;
